module.exports = __webpack_public_path__ + "static/media/yourpayment.89ca21ac.png";